// userThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { LOGIN_BY_PHONE, LOGIN_USER } from "../../utils/queries";
import { logoutAndResetStore } from "../slices/authSlice";
import { message } from "antd";

export const loginAdminThunk = createAsyncThunk(
  "authSlice/loginAdminThunk",
  async ({ userName, password, otpLogIn }, thunkAPI) => {
    const query = LOGIN_USER;

    try {
      const response = await fetch(process.env.REACT_APP_USER, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query,
          variables: {
            userName: userName,
            password: password,
            otpLogIn: otpLogIn,
          },
        }),
      });

      const json = await response.json();

      if (json.errors) {
        message.error(json.errors[0].message);
        return thunkAPI.rejectWithValue(json.errors[0].message);
      }
      if(json?.data?.getOAuthTokenForVendor){
        message.success("Login Successfully!");
      }

      return json.data.getOAuthTokenForVendor;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const logoutAdmin = createAsyncThunk(
  "auth/logoutAdmin",
  async (_, { getState, rejectWithValue, dispatch }) => {
    const state = getState();
    const refreshToken = state.auth.refreshToken;
    const accessToken = state.auth.token;

    if (!refreshToken || !accessToken) {
      return rejectWithValue("Missing refresh or access token");
    }
    try {
      const response = await fetch(process.env.REACT_APP_USER,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`, // ✅ Set Bearer token here
          },
          body: JSON.stringify({
            query: `
              mutation logoutCurrentSession {
                logoutCurrentSession(refreshToken: "${refreshToken}")
              }
            `,
          }),
        }
      );
      if (response.status === 401 || response.status === 410) {
        dispatch(logoutAndResetStore()); // ⬅️ Clears auth and any other slices
        message.error("Someone logged-in from another device.");
        return rejectWithValue("Unauthorized. Please login again.");
      }
      const result = await response.json();
      if (result.errors) {
        message.error(result.errors[0].message);
        return rejectWithValue(result.errors[0].message);
      }
      if(result?.data?.logoutCurrentSession){
        message.success("Logout Successfully!");
      }

      return result.data.logoutCurrentSession;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);




export const loginByPhoneThunk = createAsyncThunk(
  "loginByPhoneSice/loginByPhoneThunk",
  async ({ userName}, thunkAPI) => {
    const query = LOGIN_BY_PHONE;

    try {
      const response = await fetch(process.env.REACT_APP_USER, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query,
          variables: {
            userName: userName
          }
        }),
      });

      const json = await response.json();

      if (json.errors) {
        message.error(json.errors[0].message);
        return thunkAPI.rejectWithValue(json.errors[0].message);
      }
      if(json?.data?.getOtpForVendorLogin){
        message.success("OTP SEND Successfully!");
      }

      return json.data.getOtpForVendorLogin;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

